import * as React from "react";
import { Link, Route, Routes } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { AppShell } from "@/components/layout/AppShell";
import {
  RedirectIfAuthenticated,
  RequireAuth,
} from "@/components/guards/guards";
import { LoginPage } from "@/features/auth/LoginPage";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { UsersListPage } from "@/features/users/UsersListPage";
import { UserDetailPage } from "@/features/users/UserDetailPage";
import {
  BreederDetailPage,
  BreedersListPage,
} from "@/features/breeders/BreedersPage";
import { ListingsListPage } from "@/features/listings/ListingsListPage";
import { ListingDetailPage } from "@/features/listings/ListingDetailPage";
import { VerificationPage } from "@/features/verification/VerificationPage";
import { PlansPage } from "@/features/plans/PlansPage";
import { NotificationsPage } from "@/features/notifications/NotificationsPage";
import { ProfilePage } from "@/features/misc/SimplePages";
import { EmptyState } from "@/components/ui/primitives";
import { Button } from "@/components/ui/button";

const NotFound = () => (
  <EmptyState
    title="Page not found"
    description="That route does not exist in the admin panel."
    action={
      <Button variant="outline" asChild>
        <Link to="/">Back to dashboard</Link>
      </Button>
    }
    className="mt-10"
  />
);

export const App = () => {
  const bootstrap = useAuthStore((s) => s.bootstrap);

  React.useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return (
    <Routes>
      <Route
        path="/login"
        element={
          <RedirectIfAuthenticated>
            <LoginPage />
          </RedirectIfAuthenticated>
        }
      />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />

        {/* Users / Buyers */}
        <Route path="users" element={<UsersListPage />} />
        <Route path="users/:id" element={<UserDetailPage />} />

        {/* Breeders */}
        <Route path="breeders" element={<BreedersListPage />} />
        <Route path="breeders/:id" element={<BreederDetailPage />} />

        {/* Listings */}
        <Route path="listings" element={<ListingsListPage />} />
        <Route path="listings/:id" element={<ListingDetailPage />} />

        {/* Verification */}
        <Route path="verification" element={<VerificationPage />} />

        {/* Plans & Subscriptions */}
        <Route path="plans" element={<PlansPage />} />

        {/* Broadcast & Push Notifications */}
        <Route path="broadcast" element={<NotificationsPage />} />

        {/* Admin Profile & Session */}
        <Route path="profile" element={<ProfilePage />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};
